import {useRef, useState} from "react"

import {Product as ProtoProduct} from "@proto/chatbot/v1alpha/chatbot"
import {CarouselScrollPointer} from "./icons"
import Product, {IProduct} from "./Product"

interface IProps {
    message?: string
    products?: ProtoProduct[]
}

const ProductsMessage = ({message, products}: IProps) => {
    if (message === undefined && products === undefined) return

    const productsRef = useRef<HTMLDivElement>(null)
    const [isLeftActive, setLeftActive] = useState(false)
    const [isRightActive, setRightActive] = useState(true)

    const scroll = (scrollOffset: number) => {
        if (productsRef.current) {
            if (productsRef.current.scrollLeft + scrollOffset < 5) {
                setLeftActive(false)
            } else {
                setLeftActive(true)
            }
            if (productsRef.current.scrollLeft + scrollOffset > 460) {
                setRightActive(false)
            } else {
                setRightActive(true)
            }
            productsRef.current.scrollLeft += scrollOffset
        }
    }

    try {
        let prods
        if (message !== undefined && message.length > 0) {
            prods = JSON.parse(message)
        }

        if (products && products.length > 0) {
            prods = products
        }

        if (prods.length == 0) {
            return
        }

        if (prods.length == 1) {
            return <Product key="p1" product={prods[0]} />
        }

        const basePointerClass =
            "h-[40px] w-[40px] rounded-full absolute top-20 bg-white/90 border-[1px] border-input pl-[10px] pt-[10px] lg:hidden"

        return (
            <div className="relative">
                {isLeftActive ? (
                    <div className={basePointerClass + " rotate-180 cursor-pointer"} onClick={() => scroll(-256)}>
                        <CarouselScrollPointer />
                    </div>
                ) : (
                    <div className={basePointerClass + " rotate-180 "}>
                        <CarouselScrollPointer disabled={true} />
                    </div>
                )}
                <div
                    ref={productsRef}
                    className="hide-scroll-bar m-[10px] flex overflow-x-scroll scroll-smooth pb-2
                    pl-[24px] pr-[24px]"
                >
                    <div className="flex-nowra flex pl-[5px] pr-[5px]">
                        {prods.map((p: IProduct, i: number) => {
                            return <Product key={i} product={p} />
                        })}
                    </div>
                </div>
                {isRightActive ? (
                    <div className={basePointerClass + " right-0 top-20 cursor-pointer"} onClick={() => scroll(256)}>
                        <CarouselScrollPointer />
                    </div>
                ) : (
                    <div className={basePointerClass + " right-0 top-20 "}>
                        <CarouselScrollPointer disabled={true} />
                    </div>
                )}
            </div>
        )
    } catch (e) {
        return
    }
}

export default ProductsMessage
